import React, { useState } from "react";
import financialAdviceHubPages from "../utils/financialAdviceHubPages.json";
import Button from "./Buttons";
import { Link } from "gatsby";
import Container from './Container';

const visibleCount = 4;


const FinancialAdviceHubCards = () => {
    const [startIdx, setStartIdx] = useState(0);
    const [mobileShowCount, setMobileShowCount] = useState(3);

    const hubPages = financialAdviceHubPages;
    const maxIdx = hubPages.length;
    const cardsToShow = Math.min(visibleCount, maxIdx);

    const handlePrev = () => setStartIdx((idx) => (idx - 1 + maxIdx) % maxIdx);
    const handleNext = () => setStartIdx((idx) => (idx + 1) % maxIdx);

    const showArrows = maxIdx > 3;

    return (
        <Container className="py-12 lg:py-16">
            <div
                className="guide-scope col-span-full px-4 sm:px-6 lg:px-0"
                style={{ "--card-w": "clamp(180px, 22vw, 460px)", "--gap": "4rem" }}
            >
                <style>{`
                @media (min-width: 768px) and (max-width: 1023.98px) {
                    .guide-scope .cards-row { --card-w: clamp(320px, 40vw, 600px); }
                }
                `}</style>
                <div className="block md:hidden">
                    <h2 className="text-xl font-bold mb-6">Read more about Financial Advice</h2>
                    <div className="flex flex-col gap-4">
                        {hubPages.slice(0, mobileShowCount).map((hub, idx) => (
                            <Link
                                key={hub.slug + idx}
                                to={hub.slug}
                                className="border rounded-xl p-4 bg-white block transition hover:bg-[#F6F9FA]"
                                style={{ textDecoration: "none", color: "inherit" }}
                            >
                                <h3 className="font-semibold text-lg mb-1">{hub.title}</h3>
                                <p className="text-base mb-0 pb-0 text-holborn-mid-blue">{hub.description}</p>
                            </Link>
                        ))}
                        {hubPages.length > mobileShowCount && (
                            <div className="flex justify-center mt-4">
                                <Button variant="white" onClick={() => setMobileShowCount((c) => c + 3)}>
                                    Load more
                                </Button>
                            </div>
                        )}
                    </div>
                </div>

                <div className="hidden md:block">
                    <div className="flex justify-between items-center mb-8">
                        <h2 className="text-3xl font-bold">Read more about Financial Advice</h2>
                        {showArrows && (
                            <div className="flex flex-row gap-4">
                                <button className="bg-white border rounded-full px-3 py-2 shadow hover:bg-gray-100" onClick={handlePrev}>
                                    &#8592;
                                </button>
                                <button className="bg-white border rounded-full px-3 py-2 shadow hover:bg-gray-100" onClick={handleNext}>
                                    &#8594;
                                </button>
                            </div>
                        )}
                    </div>

                    <div
                        className="cards-row flex transition-all duration-300 overflow-visible gap-[var(--gap)] px-2"
                        style={{ transform: `translateX(calc(-1 * (${startIdx} * (var(--card-w) + var(--gap)))))`, width: "100%", margin: "0 auto" }}
                    >
                        {Array.from({ length: maxIdx + cardsToShow }).map((_, i) => {
                            const idx = i % maxIdx;
                            const hub = hubPages[idx];
                            const src = hub.image || null;

                            return (
                                <Link
                                    key={hub.slug + "-" + idx + "-" + i}
                                    to={hub.slug}
                                    className="guide-card flex-shrink-0"
                                    style={{ width: "var(--card-w)", marginBottom: "5rem", textDecoration: "none", color: "inherit" }}
                                >
                                    <div className="relative bg-white hover:bg-[#F6F9FA] rounded-2xl p-6 shadow-[0_2px_12px_0_rgba(20,30,60,0.12)] transition-colors duration-150 cursor-pointer h-full flex flex-col">
                                        {src && (
                                            <div className="mb-6 overflow-hidden rounded-lg" style={{ aspectRatio: "16 / 9" }}>
                                                <img
                                                    src={src}
                                                    alt={hub.title}
                                                    className="w-full h-full object-cover"
                                                    onError={(e) => (e.currentTarget.style.display = "none")}
                                                />
                                            </div>
                                        )}
                                        <h3 className="font-semibold text-xl mb-2">{hub.title}</h3>
                                        <p className="text-base mb-0 pb-0 text-holborn-mid-blue">{hub.description}</p>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default FinancialAdviceHubCards;